import React, { ChangeEvent } from 'react';
import { TextField, TextFieldProps, Grid, GridProps } from '@material-ui/core';
import StateSelectField, { StateSelectFieldProps } from '../StateSelectField';

export type DomesticAddressFieldGroupProps = {
  ContainerComponentProps?: GridProps;
  Address1Props?: TextFieldProps;
  Address2Props?: TextFieldProps;
  CityProps?: TextFieldProps;
  PostalCodeProps?: TextFieldProps;
  StateProps?: StateSelectFieldProps;
  error?: string | undefined;
  value?: DomesticAddressFields;
  onChange?: (value: DomesticAddressFields) => void;
  onBlur?: (value: DomesticAddressFields) => void;
};

export type DomesticAddressFields = {
  [key: string]: string | boolean | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  city?: string | undefined;
  postalCode?: string | undefined;
  state?: string | undefined;
  county?: string | undefined;
  stateOrProvince?: string;
};

const DomesticAddressFieldGroup = ({
  onChange = () => undefined,
  ContainerComponentProps,
  value: valueProp,
  Address1Props,
  Address2Props,
  CityProps,
  PostalCodeProps,
  StateProps,
  error,
}: DomesticAddressFieldGroupProps): JSX.Element => {
  const address1Name = Address1Props?.name || 'address1';
  const address2Name = Address2Props?.name || 'address2';
  const cityName = CityProps?.name || 'city';
  const postalCodeName = PostalCodeProps?.name || 'postalCode';
  const stateName = StateProps?.name || 'state';

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newProp = { ...valueProp, [name]: value };
    onChange(newProp);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = (e: any) => {
    const newProp = { ...valueProp, [stateName]: e };

    onChange(newProp);
  };

  return (
    <Grid container {...ContainerComponentProps}>
      <Grid item xs={6}>
        <TextField
          label="Address 1"
          aria-label="Address 1"
          data-testid="domestic-address-address-1"
          name={address1Name}
          fullWidth
          value={valueProp?.[address1Name] || ''}
          {...Address1Props}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Address 2"
          aria-label="Address 2"
          data-testid="domestic-address-address-2"
          name={address2Name}
          fullWidth
          value={valueProp?.[address2Name] || ''}
          {...Address2Props}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="City"
          aria-label="City"
          data-testid="domestic-address-city"
          name={cityName}
          fullWidth
          {...CityProps}
          value={valueProp?.[cityName] || ''}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={3}>
        <StateSelectField
          label="State"
          data-testid="domestic-address-state-select"
          helperText={error}
          name={stateName}
          fullWidth
          value={(valueProp?.[stateName] as string) || ''}
          {...StateProps}
          onChange={handleSubmit}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label="Postal Code"
          aria-label="Postal Code"
          data-testid="domestic-address-postal-code"
          name={postalCodeName}
          fullWidth
          value={valueProp?.[postalCodeName] || ''}
          {...PostalCodeProps}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
};

export default DomesticAddressFieldGroup;
